import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "./style.scss";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { constants, BASE_CURRENCY } from "common";
import { Formik, Form } from "formik";
import { paymentSchema } from "common/schemas";
import Grid from "@mui/material/Grid";
import { InputField } from "components/input-field";
import { GenericButton } from "components/generic-button";
import { GrClose } from "react-icons/gr";
import { colors } from "common/theme";

export const PayWithStripe = ({ show, handleClose, setApiResponse }) => {
  const { placeholders } = constants;
  // const stripe = useStripe();
  const elements = useElements();
  const handleCardFieldChange = (event, name) => {
    if (event.error) {
      setStripeError((other) => ({ other, [name]: event.error.message }));
    } else {
      setStripeError((other) => ({ other, [name]: null }));
    }
  };
  const [stripeError, setStripeError] = useState({
    cardName: "",
    cardNumber: "",
    cardExpiry: "",
    cardCvc: "",
  });
  const CreateCardStripe = async (cardName, loadingFalse) => {
    try {
      // Call server-side Netlify Function instead of using Stripe SDK client-side
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          brand: window.location.hostname.includes('.co.uk') ? 'uk' : 'io',
          currency: window.location.hostname.includes('.co.uk') ? 'gbp' : BASE_CURRENCY.toLowerCase(),
          productName: 'New Private Plan',
          unitAmount: 2400,
          interval: 'year',
          intervalCount: 1,
          successUrl: `${constants.siteBaseURL}/sign-up?session_id={CHECKOUT_SESSION_ID}`,
          cancelUrl: `${constants.siteBaseURL}/setup/subscription`,
        }),
      });

      const data = await response.json();
      if (data?.url) {
        window.location.assign(data.url);
      } else {
        console.error('No checkout URL returned');
      }
    } catch (err) {
      console.error('Error creating checkout session');
    }
    if (loadingFalse) loadingFalse();
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Body>
        {/* <div className="add-payment-popup-wrapper">
          <div className="top-add-payment-container">
            <span>{""} </span>
            <GrClose
              className="add-payment-close-btn"
              onClick={handleClose}
              size={20}
              color={colors.primary}
            />
          </div>
          <Formik
            initialValues={{
              cardHolderName: "",
            }}
            validateOnMount={true}
            onSubmit={(values, formikActions) => {
              CreateCardStripe(values.cardHolderName, () =>
                formikActions.setSubmitting(false)
              );
            }}
            validationSchema={paymentSchema}
            enableReinitialize
          >
            {({
              handleChange,
              handleBlur,
              handleSubmit,
              touched,
              errors,
              values,
              setFieldValue,
              isSubmitting,
            }) => (
              <div>
                <div>
                  <div className="sign-up-form-heading">
                    <span>{"Card Holder Name"}</span>
                  </div>
                  <InputField
                    name={"cardHolderName"}
                    id={"cardHolderName"}
                    error={touched.cardHolderName && errors.cardHolderName}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.cardHolderName}
                    placeholder={placeholders.cardHolderName}
                  />
                  <>
                    <div className="sign-up-form-heading">
                      <span>{"Card Number"}</span>
                    </div>
                    <div className="card-number">
                      <CardNumberElement
                        onChange={(i) => console.log(i)}
                        required
                        options={{
                          showIcon: true,
                        }}
                      />
                    </div>
                    {stripeError?.cardNumber != "" && (
                      <span className="error-field">
                        {stripeError?.cardNumber}
                      </span>
                    )}
                  </>
                  <div className="expiry-cvc-container">
                    <div className="expiry-container">
                      <div className="sign-up-form-heading">
                        <span>{"Expiry"}</span>
                      </div>
                      <div className="card-expiry">
                        <CardExpiryElement
                          onChange={(i) =>
                            handleCardFieldChange(i, "cardExpiry")
                          }
                          required
                        />
                      </div>
                      {stripeError?.cardExpiry != "" && (
                        <span className="error-field">
                          {stripeError?.cardExpiry}
                        </span>
                      )}
                    </div>
                    <div className="cvv-container">
                      <div className="sign-up-form-heading">
                        <span>{"Cvv"}</span>
                      </div>
                      <div className="card-cvc">
                        <CardCvcElement
                          onChange={(i) => handleCardFieldChange(i, "cardCvc")}
                          required
                        />
                      </div>
                      {stripeError?.cardCvc != "" && (
                        <span className="error-field">
                          {stripeError?.cardCvc}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="save-btn-container">
                    <GenericButton
                      customStyle={"pay-now-btn-container"}
                      id="save-button"
                      buttonText={"Pay Now"}
                      onPress={handleSubmit}
                      loading={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            )}
          </Formik>
        </div> */}
        <button onClick={() => CreateCardStripe("test")}>click</button>
      </Modal.Body>
    </Modal>
  );
};
